<template>
    <div class="col-span-2 grid md:grid-cols-2 space-y-4">
        <div class="col-1">
            <label :for="input_names.select" class="block mb-1.5 text-sm">{{name}}</label>
            <select :id="input_names.select" :name="input_names.select"  v-model="type"
                    class="block w-full rounded border-gray-300 sm:text-sm focus:ring-0 focus:border-gray-400">
                <option value="off">Not required</option>
                <option value="optional">Optional</option>
                <option value="required">Required</option>
                <option value="generate_automatically">Generate automatically</option>
            </select>
            <small class="text-gray-500 mt-1 block">{{ description }}</small>
        </div>
        <div v-if="type === 'generate_automatically'" class="col-span-2 space-y-8">
            <PayoutInvoiceBillingInformation
                :billing-information="clientsPayoutInvoiceBillTo"
                :countries-requiring-state="countriesRequiringState"
                :countries="countries"
                :program="program"
            />
        </div>
    </div>
</template>
<script>
import {isValidJson} from "../../resources-builder/helpers";
import Toggle from "../../../../elements/forms/Toggle.vue";
import PayoutInvoiceBillingInformation from "./components/PayoutInvoiceBillingInformation.vue";

export default {
    name: 'CommissionClientsPayoutInvoice',
    components: {PayoutInvoiceBillingInformation, Toggle},
    props: {
        invoice_setting: {
            type: String,
            default: 'off'
        },
        clients_payout_invoice_bill_to: {
            type: String,
            default: '{}'
        },
        countries: {
            type: Array,
            default: () => []
        },
        countriesRequiringState: {
            type: Array,
            required: true,
        },
        program: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            name: 'Requirement for invoice',
            input_names: {
                select: 'clients_payout_invoice',
            },
            type: this.invoice_setting || 'off',
            clientsPayoutInvoiceBillTo: isValidJson(this.clients_payout_invoice_bill_to) ? JSON.parse(this.clients_payout_invoice_bill_to) : {},
            errors: {},
        }
    },
    computed: {
        description() {
            switch (this.type) {
                case 'optional':
                    return 'The partner can request a payout without an invoice.'
                case 'required':
                    return 'The partner must have an invoice to request a payout.'
                case 'generateAutomatically':
                    return 'An invoice will be generated automatically for each payout request.'
                default: return 'Select if an invoice is required for payout requests.'
            }
        }
    },
    methods: {}
}
</script>
